export const SELLER_INBOUND_COLUMNS = [
  {
    name  : 'code',
    label : 'Code'
  },
  {
    name  : 'tl_brand_classification',
    label : 'Brand Classification'
  },
  {
    name  : 'gender',
    label : 'Product Gender'
  },
  {
    name  : 'delivery_method',
    label : 'Delivery Method'
  },
  {
    name  : 'dropoff_location',
    label : 'Dropoff Location'
  },
  {
    name  : 'requested_date',
    label : 'Requested Date'
  },
  {
    name  : 'confirmation_status',
    label : 'Confirmation Status'
  },
  {
    name  : 'received_status',
    label : 'Received Status'
  },
  {
    name  : 'live_process_status',
    label : 'Live Process Status'
  },
  {
    name  : 'quantity',
    label : 'Inbound Quantity'
  },
  {
    name  : 'received_quantity',
    label : 'Received Qty'
  },
  {
    name  : 'received_date',
    label : 'Received Date'
  },
  {
    name  : 'pickup_scheduled',
    label : 'Scheduled'
  },
  {
    name  : 'pickup_scheduled_date',
    label : 'Scheduled Date'
  }
]

export const SELLER_COLUMNS = [
  {
    name  : 'seller_name',
    label : 'Seller Name'
  },
  {
    name  : 'seller_code',
    label : 'Seller Code'
  },
  {
    name  : 'seller_email',
    label : 'Seller Email'
  },
  {
    name  : 'seller_phone',
    label : 'Seller Mobile'
  },
  {
    name  : 'notes',
    label : 'Notes'
  },
  {
    name  : 'seller_type',
    label : 'Seller Type'
  }
]

export const CURATION_COLUMNS = [
  {
    name  : 'curation_status',
    label : 'Curation Status'
  },
  {
    name  : 'curation_curated_date',
    label : 'Curated Date'
  },
  {
    name  : 'curation_accepted_total',
    label : 'Accepted Total'
  },
  {
    name  : 'curation_rejected_total',
    label : 'Rejected Total'
  }
]
